module.exports = "pegasus_template/assets/themelp1/basic/106.png";